import './OrderTable.style.less'

import {
  BlockOutlined,
  ExportOutlined,
  FilterFilled,
  ImportOutlined,
  MoreOutlined,
  PlusOutlined,
  UndoOutlined,
} from '@ant-design/icons'
import { Button, Dropdown, Input, Menu, Select, Table, Empty } from 'antd'
import {
  massUpdateAtom,
  orderIdAtom,
  inspectionSelectionAtom,
} from '@/screens/Order/jotai/order.jotai'
import { useOrderSelectionValidation } from '../../hooks/useOrderSelectionValidation'
import SelectionBar from '../SelectionBar/SelectionBar'
import DrawerNewInspection from '../DrawerNewInspection/DrawerNewInspection'
import {
  getInspectorSetting,
  getSupplierCanCreateInspectionSetting
} from '@/screens/SystemConfigure/UserManagment/UserManagment.service'
import { getAQLPropertyValues } from '@/screens/SystemConfigure/DataManagment/DataManagement.service'
import { AQL_TYPE_VALUE } from '@/constant/aql'
import { IsStandardRole, IsSupplierRole, isInspectorRole } from '@/utils/users'
import { nestedOrderColumns, transformOrderData } from './OrderTable.transform'
import { forwardRef, useEffect, useRef, useState, useImperativeHandle } from 'react'

import OrderTableDisplayFilter from './components/OrderTableDisplayFilter/OrderTableDisplayFilter'
import OrderTableGroup from './components/OrderTableGroup/OrderTableGroup'
import PBFModalMassUpdate from '../ModalMassUpdate/PBFModalMassUpdate'
import cx from 'classnames'
import { getOrder, getOrdersAdvance } from './OrderTable.service'
import { isDark } from '@/utils/darkmode'
import {
  debounce,
  filter,
  find,
  get,
  includes,
  isEmpty,
  keyBy,
  keys,
  last,
  map,
  omitBy,
  pick,
  set,
  size,
  sortBy,
} from 'lodash'
import { themeAtom } from '@/jotai/theme.jotai'
import { useAtom } from 'jotai'
import { useQuery } from 'react-query'
import { useTranslation } from 'react-i18next'
import { Tile } from '../../PBFLandingPage'
import {
  getUrlParams,
  hiddenOrderPropertiesFN,
  isEmptyValue,
  removeUrlParams,
  setUrlParams,
  handleAdvanceFilterQueryParams,
  dateRangConverter,
  convertKeysToCamelCase,
} from '@/utils/common'
import { useAuth } from '@/providers/auth.provider'
import { useNavigate } from 'react-router-dom'
import ModalUploadOrder from '../ModalUploadOrder/ModalUploadOrder'
import { queryClient } from '@/config/react-query'
import {
  getAddOrderSetting,
  getOrderColumnTransform,
} from '../../../Order.transform'
import { useExportData } from '@/hook/useExportData'
import {
  ORDER_PAYLOAD_TYPE,
  ORDER_TEXT,
  ORDER_ADVANCE_FILTER_LISTING,
  DEFAULT_ORDER_FILTER,
  ORDER_PRESET_SORTER,
} from '../../../Order.constant'

import { useAdvanceSelectedOrderItem } from '@/jotai/inspection.jotai'
import { masterDataAtom } from '@/jotai/master.jotai'
import useMasterData from '@/hook/MasterData'
import DrawerAdvanceFilter from '@/screens/QSF/Inspection/ListInspection/components/DrawerAdvanceFilter'
import { orderAdvanceSummary } from '../../../Order.service'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
// IsSupplierRole imported above from @/utils/users
import {
  COMPANY_SETTING_HAS_EXPORT_DATA,
  COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM,
} from '@/constant/user'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import { ExportConfirmModal } from '@/components/ExportConfirmModal/ExportConfirmModal'

const {
  PBF_ORDERS,
  GET_ORDER_SUMMARY,
  PBF_ORDERS_ADVANCE_SUMMARY,
  GET_ORDER_CUSTOM_COLUMNS,
  ORDER_EXPORT_SETTING,
  GET_COMPANY_SETTING_ADVANCE_FILTER_CUSTOM,
} = PBF_QUERY_KEY
const properties = [
  { key: 'masterOrder', value: 'pbf.filter.label.master_order' },
  { key: 'season', value: 'Season' },

  { key: 'supplier', value: 'pbf.table.my_order.supplier' },
  { key: 'factory', value: 'pbf.table.my_order.factory' },
  { key: 'country', value: 'pbf.table.my_order.country' },
  // { key: 'destination', value: 'pbf.table.my_order.destination' },
  {
    key: 'productCategory',
    value: 'pbf.table.my_order.product_category',
  },
  { key: 'status', value: 'pbf.table.my_order.status' },
]
const filterIcon = <FilterFilled style={{ fontSize: '19px' }} /> // NEW: Filter icon
const undoIcon = <UndoOutlined style={{ fontSize: '19px' }} /> // NEW: Undo icon

interface Props {
  sortBy: Tile
  hideActions?: any
}

function OrderTable(props: Props, ref: any) {
  const { sortBy: sortByTile, hideActions = {} } = props

  const { t } = useTranslation()
  const [currentPage] = useState(1)
  const [isMassUpdate, setIsMassUpdate] = useState(false)
  const [group, setgroup] = useState<string>(null)
  const [display, setdisplay] = useState<string[]>([])
  const [theme] = useAtom(themeAtom)
  const [massUpdate, setMassUpdate] = useAtom(massUpdateAtom)
  const [orderIds, setOrderIds] = useAtom(orderIdAtom)
  const [modalUploadOrder, setmodalUploadOrder] = useState(false)
  const { user } = useAuth()
  const [tmpSearch, setTmpSearch] = useState(getUrlParams('search') ?? '')
  const [isAllowAddOrder, setIsAllowAddOrder] = useState<boolean>(false)
  const [tableSort, setTableSort] = useState(getUrlParams('sort') ?? '')
  const [page, setPage] = useState(getUrlParams('page') ?? 1)

  const [sorterState, setsorterState] = useState({ field: null, order: null })

  const [isOpenAdvanceFilter, setIsOpenAdvanceFilter] = useState(false) // NEW: State for Drawer visibility
  const [stateFilter, setStateFilter] = useState({}) // NEW: State for advanced filters
  const { resetAtomSelectedOrders } = useAdvanceSelectedOrderItem() // NEW: For resetting selected orders

  useMasterData() // NEW: Initialize master data
  const [masterData] = useAtom(masterDataAtom) // NEW: Master data atom

  // ── New Inspection feature state 
  const [inspectionSelectedRows, setInspectionSelectedRows] = useAtom(inspectionSelectionAtom)
  const [isInspectionDrawerOpen, setIsInspectionDrawerOpen] = useState(false)
  const [pageSize, setPageSize] = useState(
    getUrlParams('page_size') ? Number(getUrlParams('page_size')) : 10
  )
  const [supplierCanCreateInspection, setSupplierCanCreateInspection] = useState(false)
  const [hasInspectorSetting, setHasInspectorSetting] = useState(false)


  const [showSelectedOnly, setShowSelectedOnly] = useState(false)
  const savedFilterRef = useRef<{
    stateFilter: any
    tmpSearch: string
    group: string | null
    tableSort: string
    page: number | string
    pageSize: number
    urlSearch: string
  } | null>(null)
  const userCompanyId = user?.company?.id ?? user?.company_id
  const validation = useOrderSelectionValidation(inspectionSelectedRows, userCompanyId)

  const { data: rawAqlList } = useQuery(
    ['GET_AQL_LIST_ORDER_TABLE', AQL_TYPE_VALUE.DEFAULT],
    async () => {
      const res = await getAQLPropertyValues(AQL_TYPE_VALUE.DEFAULT)
      const items = res.data?.data?.data || res.data?.data || []
      const arrayToMap = Array.isArray(items) ? items : []
      return arrayToMap.map((item: any) => ({
        label: JSON.parse(item.value)?.name,
        is_default: item?.is_default,
        value: item.id,
      }))
    }
  )
  const aqlOptions = rawAqlList ?? []

  const { data: rawMeasurementAqlList } = useQuery(
    ['GET_AQL_LIST_ORDER_TABLE', AQL_TYPE_VALUE.MEASUREMENT],
    async () => {
      const res = await getAQLPropertyValues(AQL_TYPE_VALUE.MEASUREMENT)
      const items = res.data?.data?.data || res.data?.data || []
      const arrayToMap = Array.isArray(items) ? items : []
      return arrayToMap.map((item: any) => ({
        label: JSON.parse(item.value)?.name,
        is_default: item?.is_default,
        value: item.id,
      }))
    }
  )
  const measurementAqlOptions = rawMeasurementAqlList ?? []

  // Permission gating for "+ New Inspection"
  const canSeeNewInspection = (() => {
    if (IsStandardRole(user)) return false
    if (IsSupplierRole(user)) return supplierCanCreateInspection
    if (isInspectorRole(user)) return hasInspectorSetting
    return true
  })()

  const clearInspectionSelection = () => {
    setInspectionSelectedRows([])
    setOrderIds({ key: '', properties: [], orders: [] })
  }

  const handleToggleShowSelected = (on: boolean) => {
    if (on) {
      savedFilterRef.current = {
        stateFilter,
        tmpSearch: getUrlParams('search') ?? '',
        group,
        tableSort,
        page,
        pageSize,
        urlSearch: window.location.search,
      }
      setgroup(null)
      localStorage.removeItem('groupBy')
      setTmpSearch('')
      setTableSort('')
      setsorterState({ field: null, order: null })
      const emptyFilterState = {
        ...DEFAULT_ORDER_FILTER,
        ...getCustomAdvanceFilterKeys.reduce(
          (acc, key) => ({ ...acc, [key]: null }),
          {}
        ),
      }
      setStateFilter(emptyFilterState)
      navigate({ search: '' })

      setShowSelectedOnly(true)
    } else {
      const saved = savedFilterRef.current
      if (saved) {
        setgroup(saved.group)
        if (saved.group) localStorage.setItem('groupBy', saved.group)
        setTmpSearch(saved.tmpSearch)
        setTableSort(saved.tableSort)
        setPage(saved.page)
        setPageSize(saved.pageSize)
        setStateFilter(saved.stateFilter)

        navigate({ search: saved.urlSearch })
      }
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }
  }


  const { searchOrder } = ORDER_TEXT
  useImperativeHandle(ref, () => ({
    resetPage() {
      if (showSelectedOnly) {
        savedFilterRef.current = null
        setShowSelectedOnly(false)
      }
      setPage(1)
    },
  }))

  useEffect(() => {
    if (showSelectedOnly) {
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }
  }, [sortByTile])

  const {
    isLoading: isGroupLoading,
    data: groupData,
    isFetching: isGroupFetching,
    isRefetching: isGroupRefetching,
  } = useQuery(
    ['orderGroupQuery', currentPage, group, sortByTile, stateFilter],
    () => {
      let payload: { [key: string]: any } = {
        page_number: currentPage,
        page_size: 10,
        ...omitBy(stateFilter, isEmpty),
      }
      if (group && group !== 'null') set(payload, 'groupBy', group)
      if (sortByTile) {
        payload = { ...payload, sortByTile }
      }
      return getOrder(payload)
    },
    {
      enabled: !!group,
    }
  )

  const {
    data,
    isFetching: isOrderAdvanceFetching,
    isLoading: isOrderAdvanceLoading,
    isFetched: isOrderAdvanceFetched,
  } = useQuery(
    [PBF_ORDERS, sortByTile, page, tableSort, stateFilter, pageSize],
    async () => {
      const payload = {
        ...omitBy(stateFilter, isEmpty),
      }
      const queryParams = {
        page_number: page,
        page_size: pageSize,
      }
      if (sortByTile) set(queryParams, 'sortBy', sortByTile)

      if (tableSort) set(queryParams, 'sort', tableSort)

      // SPECIAL CASE FOR CUSTOM ADVANCE FILTER PAYLOAD, NEED ONLY camelCase
      const cvCamelCasePayload = convertKeysToCamelCase(
        payload,
        getCustomAdvanceFilterKeys
      )
      const response = await getOrdersAdvance(queryParams, cvCamelCasePayload)

      return transformOrderData(response?.data)
    },
    {
      keepPreviousData: true,
      enabled: !group,
    }
  )

  const { } = useQuery(
    [PBF_ORDERS_ADVANCE_SUMMARY, stateFilter],
    async () => {
      const payload = {
        ...omitBy(stateFilter, isEmpty),
      }
      const cvCamelCasePayload = convertKeysToCamelCase(
        payload,
        getCustomAdvanceFilterKeys
      )
      const resultSummary = await orderAdvanceSummary(cvCamelCasePayload)
      queryClient.setQueryData([GET_ORDER_SUMMARY], resultSummary)
    },
    {
      enabled: isOrderAdvanceFetched,
    }
  )

  const { data: dataOrderColumns = [] }: any = useQuery(
    [GET_ORDER_CUSTOM_COLUMNS],
    async () => await getOrderColumnTransform()
  )

  const exportData = useExportData({
    exportKey: 'orders',
    queryKey: ORDER_EXPORT_SETTING,
  })

  const {
    data: settingOrderAdvanceCustom,
    isFetched: isOrderAdvanceCustomFetched,
  } = useQuery([GET_COMPANY_SETTING_ADVANCE_FILTER_CUSTOM], async () => {
    const setting = await getCompanySetting(
      '',
      COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM
    )

    if (!setting) return []

    const getColumns = sortBy(
      get(setting, 'value.columns', []),
      'display_order'
    )
    const assignedObject = keyBy(getColumns, 'field')

    return assignedObject
  })
  const getCustomAdvanceFilterKeys = keys(settingOrderAdvanceCustom) || []

  useEffect(() => {
    const groupByCookie = localStorage.getItem('groupBy')
    if (!isEmptyValue(groupByCookie)) {
      setgroup(groupByCookie)
    } else {
      setgroup(null)
    }
  }, [])

  useEffect(() => {
    return () => {
      setInspectionSelectedRows([])
      setOrderIds({ key: '', properties: [], orders: [] })
    }
  }, [])

  const handleChange = (value: string) => {
    if (showSelectedOnly) {
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }
    if (!value || value === undefined || value === 'undefined') {
      localStorage.removeItem('groupBy')
      setgroup(null)
      return
    }
    localStorage.setItem('groupBy', value)
    setgroup(value)
    setTmpSearch('')
    navigate({
      search: `?${setUrlParams('search', '')}`,
    })
  }

  const selectedIdSet = new Set(inspectionSelectedRows.map((r) => r.id))

  const rowSelectionBase = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      const currentPageIdSet = new Set((data?.data ?? []).map((r: any) => r.id))
      setInspectionSelectedRows((prev) => {
        const preserved = prev.filter((r) => !currentPageIdSet.has(r.id))
        const preservedIds = new Set(preserved.map((r) => r.id))
        const toAdd = selectedRows.filter((r: any) => !preservedIds.has(r.id))
        return [...preserved, ...toAdd]
      })

      setOrderIds((prev) => {
        const nonCurrentPageIds = (prev.orders ?? []).filter((id) => !currentPageIdSet.has(id))
        const newTotalOrders = [...nonCurrentPageIds, ...(selectedRowKeys as string[])]
        setMassUpdate(newTotalOrders.length === 0)
        return {
          key: '',
          properties: [],
          orders: newTotalOrders,
        }
      })
    },
    onSelect: () => {
      setMassUpdate(false)
    },
  }

  const rowSelection = showSelectedOnly
    ? {
      ...rowSelectionBase,
      selectedRowKeys: inspectionSelectedRows.map((r) => r.id),
      onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
        setInspectionSelectedRows(selectedRows)
        setOrderIds({
          key: '',
          properties: [],
          orders: selectedRowKeys as string[],
        })
        setMassUpdate(selectedRowKeys.length === 0)
      },
    }
    : {
      ...rowSelectionBase,
      selectedRowKeys: (data?.data ?? []).filter((r: any) => selectedIdSet.has(r.id)).map((r: any) => r.id),
    }

  const navigate = useNavigate()

  const onSearch = debounce((val: string) => {
    if (showSelectedOnly) {
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }
    onSetPage(1)
    handleTableChange({}, { ...stateFilter, search: val })
  }, 500)

  const onSetPage = (page) => {
    navigate({
      search: `?${setUrlParams('page', page)}`,
    })
    setPage(page)
  }

  const validateCustomColumnSorter = (orderColumn) => {
    const sortableColumns = filter(
      map(orderColumn, (item) => {
        const fieldKey = get(item, 'key', '')
        const valueSortKey = get(item, 'sortable.key', '')
        const sortStatus = get(item, 'sortable.status', false)
        const isSortable = valueSortKey && sortStatus

        if (isSortable) {
          return {
            field: fieldKey,
            sortValue: valueSortKey,
            descend: `-${valueSortKey}`,
            ascend: valueSortKey,
          }
        }
      }),
      Boolean
    )
    return sortableColumns
  }

  const onSort = (sorter) => {
    if (showSelectedOnly) {
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }

    const hasSorterChanged =
      !isEmptyValue(sorter) &&
      (sorter.field !== sorterState.field || sorter.order !== sorterState.order)
    const customColumnSorters = validateCustomColumnSorter(dataOrderColumns)

    if (hasSorterChanged) {
      // setPage(1)
    }

    if (size(sorter)) {
      if (!isEmptyValue(sorter.order)) {
        let sortValue = ''
        const getSorting = find(
          [...ORDER_PRESET_SORTER, ...customColumnSorters],
          {
            field: sorter.field,
          }
        )

        if (getSorting) {
          sortValue = getSorting[sorter.order]
        }

        navigate({
          search: `?${setUrlParams('sort', sortValue)}`,
        })
        setTableSort(sortValue)
      } else {
        navigate({
          search: `?${removeUrlParams('sort')}`,
        })
        setTableSort('')
      }
      setsorterState({
        field: sorter.field,
        order: sorter.order,
      })
    }
  }

  const handleFetchData = async () => {
    const [permission, supplierInspect, inspectorSetting] = await Promise.all([
      getAddOrderSetting(user),
      getSupplierCanCreateInspectionSetting(),
      getInspectorSetting()
    ])
    setIsAllowAddOrder(permission)
    setSupplierCanCreateInspection(supplierInspect)
    setHasInspectorSetting(Boolean(inspectorSetting))
  }

  const setDefaultSortState = () => {
    const sort = getUrlParams('sort') ?? ''
    if (!sort) return

    const sortOrder = sort.includes('-') ? 'descend' : 'ascend'
    const sortValue = sort.startsWith('-') ? sort.slice(1) : sort

    // Check preset sorters first
    const presetSorter = find(
      ORDER_PRESET_SORTER,
      (s) => s.ascend === sortValue || s.descend === sortValue
    )

    if (presetSorter) {
      setsorterState({
        field: presetSorter.field,
        order: sortOrder,
      })
      return
    }

    // Check custom column sorters
    const customColumnSorters = validateCustomColumnSorter(dataOrderColumns)
    const customSorter = find(
      customColumnSorters,
      (s) => s.ascend === sortValue || s.descend === sortValue
    )

    if (customSorter) {
      setsorterState({
        field: customSorter.field,
        order: sortOrder,
      })
    }
  }

  const handleTableChange = (
    pagination: { current?: number },
    filters: ORDER_PAYLOAD_TYPE
  ) => {
    const { current = 1 } = pagination
    const filterData = { ...filters }
    const [strDeliveryDate] = dateRangConverter(filterData?.delivery_date)
    filterData.delivery_date = strDeliveryDate

    const allAcceptedQueries = [
      ...ORDER_ADVANCE_FILTER_LISTING,
      ...getCustomAdvanceFilterKeys,
    ]
    const cvCamelCaseQueryParams = convertKeysToCamelCase(
      filterData,
      getCustomAdvanceFilterKeys
    )

    handleAdvanceFilterQueryParams(cvCamelCaseQueryParams, {
      queriesAccepted: allAcceptedQueries,
      navigate,
    })

    onSetPage(current)

    handleSetStateFilters(filterData)
  }

  const handleSetStateFilters = (newState: any) => {
    if (showSelectedOnly) {
      savedFilterRef.current = null
      setShowSelectedOnly(false)
    }
    setStateFilter((preState) =>
      convertKeysToCamelCase(
        { ...preState, ...newState },
        getCustomAdvanceFilterKeys
      )
    )
  }

  const handleOnSubmitFilter = (dataFilter: ORDER_PAYLOAD_TYPE) => {
    handleTableChange({ current: 1 }, dataFilter)
  }

  const handleResetFilter = () => {
    const completeFilter = {
      ...DEFAULT_ORDER_FILTER,
      ...getCustomAdvanceFilterKeys.reduce(
        (acc, key) => ({ ...acc, [key]: null }),
        {}
      ),
    }

    handleTableChange({ current: 1 }, completeFilter)
    setTmpSearch('')

    resetAtomSelectedOrders()
  }

  const handleFilterParamsUrl = () => {
    const splitFN = (key) =>
      getUrlParams(key) ? getUrlParams(key).split(',') : null
    const splitDeliveryDate: any = splitFN('delivery_date')
    const strSearch = splitFN('search')?.toString()

    const getParams: ORDER_PAYLOAD_TYPE = {
      search: strSearch,
      delivery_date: splitDeliveryDate,
      suppliers: splitFN('suppliers'),
      factories: splitFN('factories'),
      style_ids: splitFN('style_ids'),
    }

    if (size(getCustomAdvanceFilterKeys)) {
      for (let key of getCustomAdvanceFilterKeys) {
        getParams[`${key}`] = splitFN(key)
      }
    }

    handleSetStateFilters(getParams)
  }

  useEffect(() => {
    // setTableSort(getUrlParams('sort') ?? '')
    handleFetchData()
  }, [])

  useEffect(() => {
    if (dataOrderColumns.length > 0) {
      setDefaultSortState()
    }
  }, [dataOrderColumns])

  useEffect(() => {
    if (isOrderAdvanceCustomFetched) {
      handleFilterParamsUrl()
    }
  }, [isOrderAdvanceCustomFetched])

  const onOpenCloseAdvanceFilterFN = () => {
    setIsOpenAdvanceFilter(!isOpenAdvanceFilter)
  }

  const hasAdvancedFilters = !!size(omitBy(stateFilter, isEmpty))
  const isEmptyFiltering =
    !hasAdvancedFilters && isEmptyValue(stateFilter['search'])

  const sortingDataFilter = pick(stateFilter, [
    ...ORDER_ADVANCE_FILTER_LISTING,
    ...getCustomAdvanceFilterKeys,
  ])

  return (
    <>
      <div className="group-order-container">
        <div className="group-order-left">
          <div className="order-search-input-container">
            <Input.Search
              key={showSelectedOnly ? 'selected-only-search' : 'main-search'}
              className="order-search-container"
              placeholder={searchOrder}
              size="large"
              value={tmpSearch}
              onChange={(e) => {
                setTmpSearch(e.target.value)
                onSearch(e.target.value)
              }}
              disabled={!isEmptyValue(group)}
            />
          </div>
          <div className="group-order-filter">
            <label
              className={`${group && group !== 'null' ? 'active-group' : ''}`}
            >
              {/* <ApartmentOutlined className="icon" /> */}
            </label>
            <Select
              className="select"
              allowClear
              size="large"
              value={group}
              placeholder="Group by"
              style={{ width: 160 }}
              onChange={handleChange}
            >
              {properties.map(({ key, value }) => (
                <Select.Option key={key} value={key}>
                  {t(value)}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="group-order-filter" style={{ marginLeft: 24 }}>
            <label
              className={`${display?.length && display?.length !== 8 ? 'active-group' : ''
                }`}
            >
              {/* <LayoutOutlined className="icon" /> */}
            </label>
            <OrderTableDisplayFilter
              dataSource={dataOrderColumns}
              onChange={(value) => {
                setdisplay(value)
              }}
              user={user}
            />
          </div>
          <Button
            className={`button-advance-filter ${isEmptyFiltering && 'grey-bg'}`}
            size="large"
            type="primary"
            icon={filterIcon}
            onClick={onOpenCloseAdvanceFilterFN}
          />
          <Button
            className="button-clear-filter"
            disabled={isEmptyFiltering}
            type="link"
            icon={undoIcon}
            onClick={handleResetFilter}
          >
            Clear
          </Button>
        </div>
        <div className="order-table-actions">
          {/* "..." icon-only Actions menu (Import, Export, Mass Update) */}
          {!IsSupplierRole(user) && !isInspectorRole(user) && (
            <Dropdown
              trigger={['click']}
              overlay={
                <Menu>
                  {isAllowAddOrder && (
                    <Menu.Item key="import" className="action-dropdown-item">
                      <Button
                        size="large"
                        icon={<ImportOutlined />}
                        onClick={() => setmodalUploadOrder(true)}
                      >
                        Import Orders
                      </Button>
                    </Menu.Item>
                  )}

                  {exportData.exportConfigs?.map((item) => (
                    <Menu.Item key={item.name} className="action-dropdown-item">
                      <Button
                        size="large"
                        icon={<ExportOutlined />}
                        onClick={() => exportData.handleExportClick(item)}
                        loading={exportData.isExporting}
                      >
                        {item.title}
                      </Button>
                    </Menu.Item>
                  ))}

                  <Menu.Item key="mass-update" className="action-dropdown-item">
                    <Button
                      size="large"
                      icon={<BlockOutlined />}
                      disabled={massUpdate || orderIds.orders.length === 0}
                      onClick={() => setIsMassUpdate(true)}
                    >
                      Mass Update
                    </Button>
                  </Menu.Item>
                </Menu>
              }
            >
              <Button className="action-button with-text" size="large">
                Actions <MoreOutlined />
              </Button>
            </Dropdown>
          )}

          {isAllowAddOrder && !IsSupplierRole(user) && !isInspectorRole(user) && (
            <Button
              hidden={hiddenOrderPropertiesFN(hideActions, 'create')}
              type="primary"
              size="large"
              icon={<PlusOutlined />}
              style={{ marginLeft: 24 }}
              onClick={() => {
                navigate(`orders/edit-order`)
              }}
            >
              New Order
            </Button>
          )}
        </div>
      </div>

      <SelectionBar
        selectedCount={inspectionSelectedRows.length}
        isValid={validation.isValid}
        tooltipText={validation.tooltipText}
        canSeeNewInspection={canSeeNewInspection}
        showSelectedOnly={showSelectedOnly}
        onToggleShowSelected={handleToggleShowSelected}
        onClearAll={clearInspectionSelection}
        onCreateInspection={() => setIsInspectionDrawerOpen(true)}
        // onMassUpdate={() => setIsMassUpdate(true)} TODO : Add Mass Update functionality for SelectionBar if needed
      />

      <div style={{ marginTop: 24 }}>
        {showSelectedOnly ? (
          <Table
            sticky
            className={cx(
              isDark(theme) && 'dark-table',
              'table-container table-left'
            )}
            rowKey="id"
            rowSelection={rowSelection}
            loading={false}
            dataSource={inspectionSelectedRows}
            columns={nestedOrderColumns(
              display,
              t,
              user,
              dataOrderColumns,
              hideActions,
              getUrlParams('sort')
            )}
            onChange={(_, filters, sorter: any) => {
              onSort(sorter)
            }}
            scroll={{
              x: 'max-content',
            }}
            tableLayout="auto"
            pagination={false}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <div style={{ padding: '20px 0' }}>
                      <strong style={{ display: 'block', fontSize: '16px', marginBottom: '8px' }}>
                        No orders selected
                      </strong>
                      <span style={{ color: '#8c8c8c' }}>
                        Select orders from the list to review them here.
                      </span>
                    </div>
                  }
                />
              ),
            }}
          />
        ) : group === null ? (
          <Table
            sticky
            className={cx(
              isDark(theme) && 'dark-table',
              'table-container table-left'
            )}
            rowKey="id"
            rowSelection={rowSelection}
            loading={isOrderAdvanceLoading || isOrderAdvanceFetching}
            dataSource={data?.data ?? []}
            columns={nestedOrderColumns(
              display,
              t,
              user,
              dataOrderColumns,
              hideActions,
              getUrlParams('sort')
            )}
            onChange={(_, filters, sorter: any) => {
              onSort(sorter)
            }}
            scroll={{
              x: 'max-content',
            }}
            tableLayout="auto"
            pagination={{
              pageSize: pageSize,
              current: Number(page),
              total: data?.pagination?.total_record,
              onChange: (page) => onSetPage(page),
              showSizeChanger: true,
              onShowSizeChange: (_, size) => {
                const queryParams = new URLSearchParams(window.location.search)
                queryParams.set('page_size', size.toString())
                queryParams.set('page', '1')
                navigate({
                  search: `?${queryParams.toString()}`,
                })
                setPageSize(size)
                setPage(1)
              },
              showLessItems: true,
            }}
          />
        ) : (
          <OrderTableGroup
            groupData={groupData}
            display={display}
            sortBy={sortByTile}
            loading={isGroupLoading || isGroupFetching || isGroupRefetching}
            dataOrderColumns={dataOrderColumns}
            hideActions={hideActions}
          />
        )}
      </div>

      {isMassUpdate && (
        <PBFModalMassUpdate
          orderSelectedCount={orderIds.orders.length}
          visible={isMassUpdate}
          onClose={() => {
            setIsMassUpdate(false)
          }}
        />
      )}

      {modalUploadOrder && (
        <ModalUploadOrder
          onClose={() => {
            setmodalUploadOrder(false)
            queryClient.refetchQueries(['summaryQUery'])
            queryClient.refetchQueries([PBF_ORDERS])
            queryClient.invalidateQueries([
              PBF_QUERY_KEY.PBF_ORDERS_ADVANCE_SUMMARY,
            ])
          }}
          visible={modalUploadOrder}
          data={null}
          onSave={null}
        />
      )}

      <ExportConfirmModal
        open={exportData.isModalOpen}
        onClose={exportData.closeModal}
        onConfirm={exportData.handleConfirmExport}
        title={exportData.selectedItem?.title || 'Export Data'}
        loading={exportData.isExporting}
        error={exportData.exportError}
      />
      {isOpenAdvanceFilter && (
        <DrawerAdvanceFilter
          isOpen={isOpenAdvanceFilter}
          onClose={onOpenCloseAdvanceFilterFN}
          dataSource={{}}
          dataFilter={sortingDataFilter} // Listing item by ordering
          onSubmit={handleOnSubmitFilter}
          drawerMode="myOrders"
          options={{
            customTitle: {
              style_ids: { name: 'Style No.' },
              ...settingOrderAdvanceCustom,
            },
          }}
        />
      )}
      <DrawerNewInspection
        open={isInspectionDrawerOpen}
        selectedRows={inspectionSelectedRows}
        validation={validation}
        userRole={user?.subscription?.role_access?.role ?? ''}
        aqlOptions={aqlOptions}
        measurementAqlOptions={measurementAqlOptions}
        onClose={() => setIsInspectionDrawerOpen(false)}
        onSuccess={() => {
          setIsInspectionDrawerOpen(false)
          clearInspectionSelection()
        }}
      />
    </>
  )
}

export default forwardRef(OrderTable)
